// mobile popup status
import { createSlice } from "@reduxjs/toolkit";
import { HYDRATE } from "next-redux-wrapper";

interface IPopup {
  productFilterVisible: boolean // product page, mobile filters popup is visible
  productAttrSelectVisible: boolean // product detail page, proudct specification popup is visible
}

const initialState: IPopup = {
  productFilterVisible: false,
  productAttrSelectVisible: false,
};

const appSlice = createSlice({
  name: "mobilePopup",
  initialState,
  reducers: {
    setProductFilterVisible: (state, action) => {
      state.productFilterVisible = action.payload
    },
    setProductAttrSelectVisible: (state, action) => {
      state.productAttrSelectVisible = action.payload
    }
  },
  extraReducers: {
    // hydrated 用于获取服务端注入的state并选择更新
    [HYDRATE]: (state, action) => {
      return {
        ...action.payload.user,
      };
    },
  },
});

export const { setProductFilterVisible, setProductAttrSelectVisible } = appSlice.actions;
export default appSlice.reducer;
